import { useNavigate } from "react-router-dom";
import { Coins, Smile, Globe, ShieldCheck, ArrowRight } from "lucide-react";
import { Header } from "@/components/Header";
import { useLang } from "@/context/LangContext";
import { METERS } from "@/lib/engine";

const ICONS = { eco: Coins, hap: Smile, intl: Globe, stab: ShieldCheck };
const COLORS = { eco: "var(--m-eco)", hap: "var(--m-hap)", intl: "var(--m-intl)", stab: "var(--m-stab)" };

export default function Intro() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div className="max-w-md mx-auto min-h-dvh px-5 pb-6 flex flex-col" data-testid="intro-screen">
      <Header />
      <div className="flex-1 flex flex-col justify-center gap-6 py-6">
        <div className="rise">
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-[var(--gold)]">{t.introTitle}</div>
          <p className="mt-3 text-base leading-relaxed text-[var(--text-light)]/85" data-testid="intro-text">{t.introText}</p>
          <p className="mt-2 font-display font-bold text-[var(--gold)]" data-testid="intro-goal">{t.termGoal}</p>
        </div>
        <div className="grid gap-3">
          {METERS.map((k, i) => {
            const Icon = ICONS[k];
            return (
              <div key={k} className={`rise d${i + 1} panel flex items-center gap-4 p-4`} data-testid={`intro-meter-${k}`}>
                <div className="w-12 h-12 rounded-2xl flex items-center justify-center shrink-0" style={{ background: COLORS[k] }}><Icon size={24} color="#fff" /></div>
                <div>
                  <div className="font-display font-bold text-base">{t.meters[k]}</div>
                  <div className="text-sm text-[var(--text-light)]/65">{t.meterDesc[k]}</div>
                </div>
              </div>
            );
          })}
        </div>
        <button onClick={() => navigate("/play")} className="rise d5 btn-gold w-full py-4 text-lg flex items-center justify-center gap-2" data-testid="start-term-btn">{t.startTerm} <ArrowRight size={20} /></button>
      </div>
    </div>
  );
}
